import { Controller } from "@hotwired/stimulus"
import * as Bootstrap from 'bootstrap';

export default class extends Controller {
  copyText(event) {
    const answerElement = event.target;
    const textToCopy = answerElement.innerText;
    navigator.clipboard.writeText(textToCopy).then(() => {
      const tooltip = Bootstrap.Tooltip.getOrCreateInstance(event.target, {
        title: "Copied!",
        trigger: 'click'
      });

      tooltip.show();
      setTimeout(() => {
        tooltip.hide();
      }, 2000);
    }).catch((error) => {
      Sentry.withScope((scope) => {
        scope.setExtra("note", "Clipboard operation failed");
        Sentry.captureException(error);
      });
    });
  }
}